// extracted by mini-css-extract-plugin
export default {"panel":"Error_panel__lkCc1"};